import {ObjectImageCarousel} from "./ObjectImageCarousel";
import {Link} from "react-router";
import {UnitRoomMapCard} from "./unit/UnitRoomMapCard";
import React from "react";
import {IObject} from "../interfaces/IObject";

export function ObjectCard({object}: { object: IObject }) {

  return <article key={object.id}>
    <div data-component="ObjectImageCarousel">
      <ObjectImageCarousel images={object.images}/>
    </div>
    <main>
      <h2><Link to={'/storefront/' + object.name}>{object.name}</Link></h2>
      <div data-component="UnitRoomMapCard">
        <UnitRoomMapCard
          url={"/"}
          rooms={object.room_data}/>
      </div>
    </main>
  </article>
}